
















































































import { Component, Vue } from 'vue-property-decorator';
import Headerhome from '../../components/headerhome.vue';

@Component({
  components: { Headerhome },
})
export default class AboutPage extends Vue {

  get getLanguage(){
   return this.$root.$i18n.locale;
  }
}
